module.exports = __webpack_public_path__ + "img/exercise.bf418956.jpg";